import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var ThumbUpIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5a1 1 0 0 0-1 1v1a5 5 0 0 1-4 4.899V17a2 2 0 0 0 2 2h7a1 1 0 0 1 .085.004c.087.007.238-.018.43-.21.2-.2.396-.54.508-1.007l.974-4.87A1 1 0 0 0 18 12h-3a1 1 0 0 1-1-1V6a1 1 0 0 0-1-1ZM7.6 20.2A1.997 1.997 0 0 1 6 21H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3a3 3 0 0 0 3-3V6a3 3 0 0 1 6 0v4h2a3 3 0 0 1 3 3 1 1 0 0 1-.02.196l-1 5-.006.032c-.177.752-.524 1.46-1.044 1.98-.518.518-1.207.841-1.967.792H10a4 4 0 0 1-2.4-.8ZM6 12H4v7h2v-7Z",
    fill: props.fill || "currentColor"
  }
) }));

export { ThumbUpIcon };
